/* Lightweight offline queue. Stores actions in localStorage and replays them
 * when the browser reports online status. */
const KEY = "onego_offline_queue_v1";

export function readQueue() {
    try {
        return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
        return [];
    }
}

export function writeQueue(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
}

export function enqueue(action) {
    const items = readQueue();
    items.push({ ...action, id: crypto.randomUUID(), queued_at: new Date().toISOString() });
    writeQueue(items);
    return items;
}

export function clearQueue() {
    writeQueue([]);
}

export async function replay(api) {
    const items = readQueue();
    const remaining = [];
    for (const it of items) {
        try {
            await api.request({ url: it.url, method: it.method || "POST", data: it.data });
        } catch (_) {
            remaining.push(it);
        }
    }
    writeQueue(remaining);
    return { processed: items.length - remaining.length, remaining: remaining.length };
}
